// DO NOT EDIT THIS FILE

import gql from 'graphql-tag';

export const COLLAB_VERTICAL = gql`
query collabVertical($search: String) {
  collab: me {
    id
    employee {
      id
      verticalMembersEmployee(employees_User_FirstName_Icontains: $search) {
        edges {
          node {
            employees(user_FirstName: $search, user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
